<template>
    <div class="video-link">
        <div class="title">常见问题汇总</div>
        <div class="common">
                <div
                    class="problem-list"
                    v-for="item in problemList"
                    :key="item.id">
                    <div class="problem">{{item.problemName}}</div>
                    <div class="description" v-if="item.descriptionName">
                        <span class="tip">{{item.descriptionName}}</span>
                        <span class="desc">{{item.descriptionDesc}}</span>
                    </div>
                    <div class="solution" v-if="item.methodName">
                        <span class="tip">{{item.methodName}}</span>
                        <span class="desc">{{item.methodDesc}}</span>
                    </div>
                    <img :src="item.img" alt="校对时间" v-if="item.img">
                    <div class="video-tutorial" v-if="item.videoName">
                        <span class="tip">{{item.videoName}}</span>
                        <a class="desc" :href="item.videoDesc" target="_blank">{{item.videoDesc}}</a>
                    </div>
                </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    name: "Tvlink",
    data () {
        return {
            problemList: [{
                id: '',
                problemName: '',
                descriptionName: '',
                descriptionDesc: '',
                methodName: '',
                methodDesc: '',
                img: ''
            }]
        }
    },
    created () {
        // 获取数据
        this.getProblemlist()
    },
    methods: {
        // 接口静态JSON数据
        getProblemlist () {
            axios.get('/mock/problem.json')
                .then((res) => {
                    this.problemList = res.data.data.problemList
                    // console.log(this.problemList)
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.video-link {
    margin: 0 auto;
    width: 1150px;
    height: 100vh;
    background: #fff;
    .title {
        padding-top: 50px;
        width: 1150px;
        height: 100px;
        font-size: 50px;
        font-weight: bold;
        text-align: center;
    }
    .common{
        .problem-list {
            margin: 0;
            margin-bottom: 15px;
            padding: 0 50px;
            list-style: none;
            .problem {
                margin-bottom: 10px;
                font-size: 30px;
                font-weight: bold;
            }
            .description, .solution, .video-tutorial {
                margin-left: 30px;
                height: 30px;
                line-height: 30px;
                .tip {
                    color: #ff0000;
                    font-size: 20px;
                    font-weight: 550;
                }
                .desc {
                    font-size: 15px;
                }
                a {
                    color: #000;
                    text-decoration: none;
                }
            }
            img {
                margin-top: 5px;
                width: 896px;
                // height: 455px;
            }
        }
    }
}
</style>